import { render, staticRenderFns } from "./FilterWidgetMenu.vue?vue&type=template&id=70517529&scoped=true"
import script from "./FilterWidgetMenu.vue?vue&type=script&lang=js"
export * from "./FilterWidgetMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70517529",
  null
  
)

export default component.exports